<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="3">
        <template v-slot:thead>
          <tr>
            <bs-th scope="col">{{ $t('labels.title') }}</bs-th>
            <bs-th scope="col">{{ $tc('labels.customer', 1) }}</bs-th>
            <bs-th scope="col"></bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td class="clickable" @click="$router.push({ path: '/project/' + r.id })">
            <strong>{{ r.title }}</strong><br>
            <small>{{ $t('labels.managed_by', { name: find(users, 'id', r.manager_id, 'name') }) }}</small>
          </td>
          <td>
            {{ find(customers, 'id', r.customer_id, 'name') }}<br>
            <small v-if="r.property">{{ r.property.label }}</small>
          </td>
          <td class="t2">
            <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <portal to="app-modal">
      <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
        <bs-form :submit="$t('labels.submit')" @submit="submit">
          <template v-slot:default="{ error }">
            <tuxedo-input :name="'title'" :label="$t('labels.title')" v-model="resource.title" :error="error" />
            <tuxedo-select :name="'customer_id'" :label="$tc('labels.customer', 1)" v-model="resource.customer_id" :options="customers" :insistLabel="'name'" :insistReturn="'id'" :error="error" />
            <text-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="error" />
          </template>
        </bs-form>
      </bs-modal>
      <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
        <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
          {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
        </bs-form>
      </bs-modal>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'Projects',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'drafting-compass'],
      resource: {
        title: '',
        customer_id: null,
        description: null
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.projects,
      resourceState: state => state.projectsState,
      resourceStore: state => state.projectsStore,
      users: state => state.usersStore,
      customers: state => state.customersStore
    })
  }
}
</script>
